export type DebouncedFunction<T extends (...args: any[]) => unknown> = {
  (...args: Parameters<T>): void;
  cancel(): void;
  flush(): void;
};

const debounce = <T extends (...args: any[]) => unknown>(
  fn: T,
  delay: number,
): DebouncedFunction<T> => {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  let latestArgs: Parameters<T> | undefined;

  const invoke = () => {
    if (!latestArgs) return;
    const args = latestArgs;
    latestArgs = undefined;
    timeout = undefined;
    fn(...args);
  };

  const debounced = (...args: Parameters<T>) => {
    latestArgs = args;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(invoke, Math.max(0, delay));
  };

  debounced.cancel = () => {
    if (timeout) clearTimeout(timeout);
    timeout = undefined;
    latestArgs = undefined;
  };

  debounced.flush = () => {
    if (timeout) clearTimeout(timeout);
    invoke();
  };

  return debounced;
};
export default debounce;
